import {
  extractSillyTavernJsonFromPng,
  normalizeSillyTavernCard,
  type SillyTavernImportMode,
} from '@voicer/shared';
import { ws } from '../ws/client';

function errMessage(err: unknown): string {
  if (err instanceof Error) return err.message;
  if (typeof err === 'string') return err;
  return 'unknown error';
}

/**
 * Pick a SillyTavern character card (.json or .png) and import it into VOICER context.
 * `new` creates a session named after the character; `replacePersona` applies to the current session.
 */
export function importSillyTavernCard(mode: SillyTavernImportMode = 'new'): Promise<void> {
  return new Promise((resolve, reject) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.json,.png,application/json,image/png';
    input.onchange = () => {
      const f = input.files?.[0];
      if (!f) {
        resolve();
        return;
      }
      void (async () => {
        try {
          const lower = f.name.toLowerCase();
          let card: unknown;
          if (lower.endsWith('.png') || f.type === 'image/png') {
            const bytes = new Uint8Array(await f.arrayBuffer());
            const json = await extractSillyTavernJsonFromPng(bytes);
            if (!json) throw new Error('PNG has no SillyTavern character card chunk (chara/ccv3)');
            card = JSON.parse(json) as unknown;
          } else {
            card = JSON.parse(await f.text()) as unknown;
          }
          // Fail fast in the UI; proxy re-validates at the trust boundary.
          normalizeSillyTavernCard(card);
          await ws.rpc('context.importCard', { card, mode });
          resolve();
        } catch (err) {
          reject(err instanceof Error ? err : new Error(errMessage(err)));
        }
      })();
    };
    input.click();
  });
}
